module.exports = __webpack_public_path__ + "static/media/VIDEO-SPRAY2.27be2881.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/VIDEO-SPRAY2.png
// module id = 293
// module chunks = 0